import React, { useEffect, useState } from "react";
import TabComponent from "../../../layoutComponents/TabComponent";
import TableComponent from "../../../layoutComponents/TableComponent";
import {
  Box,
  ClickAwayListener,
  Grid,
  List,
  ListItem,
  Popover,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import { primary, white } from "../../../styles/colors";
import FormulaMillerTds from "../FormulaMillerTds";
import FormulaFinalRate from "../FormulaFinalRate";
import { CssTextField, StyledButton } from "../../../styles/StyledComponents";
import {
  CloudDownload,
  DataArray,
  MoreHorizOutlined,
} from "@mui/icons-material";
import {
  Brokerage,
  MillerDetails,
  TotalPayable,
} from "./MillerAccountsDetails";
import InvoiceCardUi from "../../../layoutComponents/InvoiceCardUi";

import { multiply, subtract } from "lodash";
import { Autocomplete, createFilterOptions } from "@mui/material";
import FormulaBrokerage from "../FormulaBrokerage";
import TotalPayments from "./TotalPayments";
import PoInfo from "./PoInfo";
import BagsInfo from "./BagsInfo";
import WeightInfo from "./WeightInfo";
import AmountInfo from "./AmountInfo";
import BillInfo from "./BillInfo";
import BalanceInfo from "./BalanceInfo";
import Reports from "./Reports";
import SingleBill from "./Reports/SingleBill";
import BillPDF from "./BillPDF";
import BillPDFButton from "./BillPDF";
import { CaptilizeText } from "../../../Regex";
import TransporterBalanceAmount from "./TransportBalanceAmount";
import TDSDeduction from "../../../layoutComponents/TextfieldFormulaUI/TDSDeduction";
const STATUS_OPTIONS = [
  { label: "All", value: "ALL" },
  { label: "Pending", value: "PENDING" },
  { label: "Paid", value: "PAID" },
];

const formatDate = (date) => (date ? moment(date).format("MMM Do YYYY") : "-");

// const POInfo = (singleDispatch) => (
//   <Box>
//     <Typography style={{ fontSize: "0.775rem" }}>
//       <strong>No:</strong> {singleDispatch.purchase_order_number || "-"}
//     </Typography>
//     <Box sx={{ display: "flex" }}>
//       <Typography style={{ fontSize: "0.775rem" }}>
//         <strong>Rate:</strong>{" "}
//         {singleDispatch.po_rate
//           ? `₹ ${Number(singleDispatch.po_rate).toFixed(0)}/-`
//           : "-"}
//       </Typography>
//       <Typography style={{ fontSize: "0.775rem" }}>
//         <strong>Truck:</strong> {singleDispatch.truck_number || "-"}
//       </Typography>
//     </Box>
//     <Typography style={{ fontSize: "0.775rem" }}>
//       <strong>Payment CONDITION:</strong>{" "}
//       {singleDispatch.payment_condition
//         ? `${singleDispatch.payment_condition} days`
//         : "-"}
//     </Typography>
//   </Box>
// );

const BrokerageInfo = ({ singleDispatch }) => (
  <Box>
    <Typography style={{ fontSize: "0.775rem" }}>
      <strong>Broker:</strong> {singleDispatch.broker || "-"}
    </Typography>
    {singleDispatch.brand && (
      <Typography style={{ fontSize: "0.775rem" }}>
        <strong>Brand:</strong> {singleDispatch.brand}
      </Typography>
    )}
  </Box>
);

const LoadingUnloadingInfo = ({ singleDispatch, unit }) => (
  <Box sx={{ width: "100%" }}>
    <Grid container direction="column" spacing={0.5}>
      <Grid item>
        <Typography style={{ fontSize: "0.775rem" }}>
          <strong>Load:</strong>{" "}
          {singleDispatch.load_weight
            ? `${Number(singleDispatch.load_weight).toFixed(3)} ${unit}`
            : "-"}{" "}
          / {singleDispatch["bags as per miller"] || "-"} bags
        </Typography>
      </Grid>
      <Grid item>
        <Typography style={{ fontSize: "0.775rem" }}>
          <strong>Unload:</strong> {singleDispatch.unloading_bags_number || "-"}{" "}
          bags on {formatDate(singleDispatch.arrival_date)}
        </Typography>
      </Grid>
      <Grid item>
        <Typography style={{ fontSize: "0.775rem" }}>
          <strong>Final:</strong>{" "}
          {singleDispatch.final_weight
            ? `${Number(singleDispatch.final_weight).toFixed(0)} ${unit}`
            : "-"}
        </Typography>
      </Grid>
    </Grid>
  </Box>
);

const filter = createFilterOptions();
function TransporterAccounts({
  tableList,
  userRole,
  loader,
  singlelistView,
  setLoader,
  seletedPo,
  onFilterChange,
  purchaeOrdersList,
  dispatchListAllData,
  onTabChange,
  accountsPaginationCount,
}) {
  const [selectedTab, setTab] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [downloadInvoicePdf, setDownloadInvoicePdf] = useState(false);
  const [details, setDetails] = useState({});
  const [DetailedView, setDetailed] = useState(true);
  const [popper, setPopper] = useState({ open: false });
  useEffect(() => {
    onTabChange(
      STATUS_OPTIONS[selectedTab].value === "ALL"
        ? ""
        : STATUS_OPTIONS[selectedTab].value === "PENDING"
        ? "UNPAID"
        : STATUS_OPTIONS[selectedTab].value
    );
  }, [selectedTab, window.location.pathname]);
  const DetailedHeader = [
    "Dispatch From",
    "Dispatch To",
    "Bilty No",
    "Miller Bill No",
    "Bill Date",
    "Truck No.",
    "Total Bags",
    "Bill Weight",
    "Freight Rate",
    "Total Amount",
    "Advance Amount",
    "Freight Deduction",
    "TDS Deduction (Transporter)",
    "Balance Amount",
    "Total Paid",
    "Balance",
  ];
  const CondensedHeader = [
    "PO Details",
    "Truck No.",
    "Bags",
    "Final Weight",
    "Final Rate",
    "Final Amount",
    "Remaining Balance",
    // "Status",
    "Report",
  ];
  const generatePdfList = (item) => {
    return item.map((data, i) => {
      const unit = data.unit;
      const totalAllocatedToBill = data.subList.reduce((total, singleSub) => {
        const bill = singleSub.paid_bills.find(
          (s) => s.miller_account === data.id
        );
        return bill ? total + Number(bill.allocated_to_bill) : total;
      }, 0);
      const attachUnit = (w) => `${w} ${unit}`;
      return {
        "PO NO": data.purchase_order_number,
        "Payment CONDITION": `${data.payment_condition} Days`,
        BROKER: data.broker,
        "Truck No.": data.truck_number,
        BRAND: data.brand ? data.brand : "-",
        "Miller Bill No": data.miller_bill_number,
        "BILL DATE": data.dispatch_date
          ? moment(data.dispatch_date).format("ddd, MMM Do YYYY")
          : "-",
        "Bill Weight": attachUnit(
          `${Number(data.bill_weight ?? 0).toFixed(3)}`
        ),
        "Load Weight": attachUnit(Number(data.load_weight ?? 0).toFixed(3)),
        "Total Bags": data.total_bags || "-",
        "Unloading DATE": data.arrival_date
          ? moment(data.arrival_date).format("ddd, MMM Do YYYY")
          : "-",
        "PORT NET WEIGHT": attachUnit(
          Number(data.port_net_weight ?? 0).toFixed(3)
        ),
        "Unloading Bags Number": `${data.unloading_bags_number} bags`,
        "FINAL WEIGHT": attachUnit(Number(data.final_weight ?? 0).toFixed(3)),
        "BILL RATE": `${Number(data.bill_rate ?? 0).toFixed(0)}`,
        "PO Rate": `${Number(data.po_rate ?? 0).toFixed(0)}`,
        "Discount Expiry Date": data.miller_discount_expiry_date
          ? moment(data.miller_discount_expiry_date).format("ddd, MMM Do YYYY")
          : "",
        "CD (%)": `${Number(data.cash_discount).toFixed(2)}%`,
        "CD Amount": `${Number(data.miller_discounted_amount).toFixed(0)}`,
        "FINAL RATE": `${Number(data.final_rate ?? 0).toFixed(0)}`,
        "Miller GST Charge": `${Number(data.miller_gst_charge ?? 0).toFixed(
          2
        )}%`,
        "Miller advance": `${Number(data.miller_advance ?? 0).toFixed(0)}`,
        "Miller Bill Amount": `${Number(data.miller_bill_amount ?? 0).toFixed(
          0
        )}`,
        "Miller TDS": `${multiply(
          subtract(data.miller_bill_amount, data.miller_gst_charge),
          data.miller_tds
        )}`,

        "BROKERAGE Amount for BRIPL": Number(
          `${Number(data.brokerage_amount_for_bri ?? 0).toFixed(0)}`
        ),
        "Other deduction": `${Number(data.other_deduction ?? 0).toFixed(0)}`,
        "FINAL AMOUNT": `${Number(data.miller_final_amount ?? 0).toFixed(0)}`,
        "BROKERAGE Amount for Miller": Number(data.final_weight * 150),
        "Total Paid": Number(`${Number(data.total_paid ?? 0).toFixed(0)}`),

        Balance: Number(
          `${Number(data.balance ?? 0)}).toFixed(0)}`
        ),
      };
    });
  };
  const generateMergedList = (item) => {
    return item.map((data, i) => {
      const unit = data.unit;
      const totalAllocatedToBill = data.subList.reduce((total, singleSub) => {
        const bill = singleSub.paid_bills.find(
          (s) => s.miller_account === data.id
        );
        return bill ? total + Number(bill.allocated_to_bill) : total;
      }, 0);
      const attachUnit = (w) => `${w} ${unit}`;
      return {
        "PO NO": data.purchase_order_number,
        [CondensedHeader[0]]: "XYZ/25-26/0013",
        [`${CondensedHeader[0]}UI`]: () => {
          return <PoInfo data={data} />;
        },
        [CondensedHeader[2]]: "wefwef",
        [`${CondensedHeader[2]}UI`]: () => {
          return <BagsInfo data={data} />;
        },
        [CondensedHeader[3]]: "wefwef",
        [`${CondensedHeader[3]}UI`]: () => {
          return <WeightInfo data={data} />;
        },
        [CondensedHeader[4]]: "wefwef",
        [`${CondensedHeader[4]}UI`]: () => {
          return <BillInfo data={data} />;
        },
        [CondensedHeader[5]]: "wefwef",
        [`${CondensedHeader[5]}UI`]: () => {
          return <AmountInfo data={data} />;
        },
        [CondensedHeader[6]]: "wefwef",
        [`${CondensedHeader[6]}UI`]: () => {
          return <BalanceInfo data={data} />;
        },
        // "Payment CONDITION": `${data.payment_condition} Days`,
        // BROKER: data.broker,
        "Truck No.": data.truck_number,
        "Dispatch From": data.dispatched_from || "-",
        "Dispatch To": data.dispatched_to || "-",
        // BRAND: data.brand,
        "Miller Bill No": data.bill_number,
        "Bilty No": data.bilty_number || "-",
        "Bill Date": data.bill_date
          ? moment(data.bill_date).format("ddd, MMM Do YYYY")
          : "",
        "Bill Weight": attachUnit(
          `${Number(data.bill_weight ?? 0).toFixed(3)}`
        ),
        "Load Weight": attachUnit(Number(data.load_weight ?? 0).toFixed(3)),
        "Total Bags": data.total_bags || "-",
        "Freight Rate": `${Number(data.freight_rate ?? 0).toFixed(2)}/-`,
        "Total Amount": `₹ ${Number(data.total_freight ?? 0).toFixed(0)}`, 
        "Freight Deduction": `₹ ${Number(data.freight_deduction ?? 0).toFixed(2)}`,
        "Advance Amount": `₹ ${Number(data.transporter_advance ?? 0).toFixed(2)}`,
        "Balance Amount": `wefwef`,
        [`${"Balance Amount"}UI`]: () => {
          return (
            <div className="d-flex align-items-center">
              <span>₹ {Number(data.transporter_balance ?? 0).toFixed(2)}</span>
          <TransporterBalanceAmount 
            total={Number(data.total_freight ?? 0).toFixed(0)} 
            advance={Number(data.transporter_advance ?? 0).toFixed(0)}
            freightDeduction={Number(data.freight_deduction ?? 0).toFixed(0)}
            tdsDeduction={Number(data.tds_deduction ?? 0).toFixed(0)}
          />
          </div>
          );
        },
        "TDS Deduction (Transporter)": `wefwef`,
        [`${"TDS Deduction (Transporter)"}UI`]: () => {
          return (
            <div className="d-flex align-items-center">
              <span>₹ {Number(data.tds_deduction ?? 0).toFixed(2)}</span>
          <TDSDeduction 
            totalFreight={Number(data.total_freight ?? 0).toFixed(0)} 
            transportTDS={Number(data.transporter_tds ?? 0).toFixed(0)}
          />
          </div>
          );
        },
        "Total Paid": `₹ ${Number(data.total_paid ?? 0).toFixed(2)}`,
        "Balance": `₹ ${Number(data.balance ?? 0).toFixed(2)}`,
        Report: "Download",
        ReportUI: () => {
          const generateMergedList = (s) => {
            return s.map((singleSub) => {
              const newObj = {};
              newObj["Date"] = moment(singleSub.payment_date).format(
                "ddd, MMM Do YYYY"
              );
              newObj["Payment Id"] = singleSub.payment_id;
              newObj["Payment Amount"] = singleSub.paid_bills.find(
                (s) => s.miller_account === data.id
              )
                ? Number(
                    singleSub.paid_bills.find(
                      (s) => s.miller_account === data.id
                    ).allocated_to_bill
                  ).toFixed(0)
                : "";
              newObj["Payment Status"] = singleSub.payment_status;
              newObj["Recorded By"] = singleSub.recorded_by;
              newObj["Verified By"] = singleSub.verified_by;
              return newObj;
            });
          };
          return (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <SingleBill
                subList={data.subList ? generateMergedList(data.subList) : []}
                list={generatePdfList([data])}
                header={DetailedHeader}
                millerName={singlelistView.name}
              />
            </div>
          );
        },
      };
    });
  };

  const filterBypo = () => {
    return (
      <div className="d-flex width-100">
        {/* <div
          className="d-flex"
          style={{
            border: "1px solid rgba(0, 0, 0, 0.23)",
            // width: "calc(100% - 386px)",
            borderRadius: "4px",
            marginRight: "10px",
          }}
        >
          <div
            className="d-flex alignC textOEllipse"
            onClick={() => {
              if (!DetailedView) {
                setDetailed(true);
              }
            }}
            style={{
              borderRight: "1px solid rgba(0, 0, 0, 0.23)",
              padding: "5px 12px",
              cursor: !DetailedView ? "pointer" : "inherit",
              background: DetailedView ? primary : "inherit",
              color: DetailedView ? white : "inherit",
              fontSize: 13
            }}
          >
            Detailed View
          </div>{" "}
          <div
            className="d-flex alignC textOEllipse"
            style={{
              padding: "5px 12px",
              cursor: DetailedView ? "pointer" : "inherit",
              background: !DetailedView ? primary : "inherit",
              color: !DetailedView ? white : "inherit",
              fontSize: 13
            }}
            onClick={() => {
              if (DetailedView) {
                setDetailed(false);
              }
            }}
          >
            Condensed View
          </div>
        </div> */}
        <div style={{ width: "300px" }}>
          <Autocomplete
            value={seletedPo ? seletedPo : ""}
            onChange={(e, newValue) => {
              onFilterChange(newValue);
            }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
              return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            options={purchaeOrdersList ?? []}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                return option;
              }
              // Add "xxx" option created dynamically
              if (option.inputValue) {
                return option.inputValue;
              }
              // Regular option
              return option["po_number"] ? option["po_number"].toString() : "";
            }}
            id="po"
            variant="outlined"
            required={true}
            // renderTags={(value, getTagProps) =>
            //   value.map((option, index) => (
            //     <Chip
            //       variant="outlined"
            //       label={option}
            //       {...getTagProps({ index })}
            //     />
            //   ))
            // }
            renderOption={(props, option) => (
              <li {...props} style={{ textTransform: "capitalize" }}>
                {option["po_number"]}
              </li>
            )}
            sx={{
              width: "100%",
              padding: "0",
              "& .MuiInputBase-root": {
                padding: "9.5px !important",
              },
              "& .MuiOutlinedInput-input": {
                padding: "0 !important",
              },
            }}
            renderInput={(params) => (
              <CssTextField
                {...params}
                label="Filter by Purchase Order"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
                // disabled={onlyCreate && onlyCreate.broker_profile ? true : false}
              />
            )}
          />
        </div>
        <div
          style={{ display: "flex", flexDirection: "row", marginLeft: "10px" }}
        >
        <BillPDFButton 
                            tableList={tableList} 
                            transportId={singlelistView.id} 
                            brokerName={CaptilizeText(singlelistView?.name || "")} 
                          />
          <Reports
            list={generatePdfList(tableList)}
            header={DetailedHeader}
            millerName={singlelistView.name}
          />
        </div>
      </div>
    );
  };

  const pdfFormat = (data) => {
    return {
      // "Payment Datetime":"efer",
      ...data,
      "Invoice Number": data.invoice_number,
      // "Payment Status": data.payment_status,
      "Whose Payment": data.whose_payment ?? "",
      "Final Amount": `₹  ${Number(popper.parent?.miller_final_amount).toFixed(
        0
      )}/-`,
      "Payment Amount": `₹  ${Number(data.payment_amount).toFixed(0)}/-`,
      "Unpaid Amount": `₹   ${subtract(
        popper.parent?.miller_final_amount,
        data.total_paid_amount
      ).toFixed(0)}/-`,
      "Recorded By": data.recorded_by,
      "Verified By": data.verified_by,
    };
  };
  const setData = (singleDispatch, userRole) => {
    const unit = singleDispatch.po_unit;

    return {
      ...singleDispatch,
      "UN DATE": "",
      "UN BAGS": singleDispatch.unloading_bags_number,
      "CD (%)": `${Number(singleDispatch.cash_discount).toFixed(2)}%`,
      "CD Amount": `${Number(singleDispatch.miller_discounted_amount).toFixed(
        0
      )}/-`,
      "PO Details": () => <PoInfo singleDispatch={singleDispatch} />,
      "BROKER/BRAND": () => <BrokerageInfo singleDispatch={singleDispatch} />,
      "Loading / Unloading Info": () => (
        <LoadingUnloadingInfo singleDispatch={singleDispatch} unit={unit} />
      ),
      "Bill & CD Summary": () =>
        singleDispatch.bill_rate ? (
          <Box>
            <Typography style={{ fontSize: "0.775rem" }}>
              <strong>Bill Rate:</strong> ₹{" "}
              {Number(singleDispatch.bill_rate).toFixed(0)}/-
            </Typography>
            <Typography style={{ fontSize: "0.775rem" }}>
              <strong>Discount Amt:</strong> ₹{" "}
              {Number(singleDispatch.miller_discounted_amount).toFixed(0)}/- (
              {Number(singleDispatch.cash_discount).toFixed(2)}%)
            </Typography>
            <Typography style={{ fontSize: "0.775rem" }}>
              <strong>Final Rate:</strong> ₹{" "}
              {Number(singleDispatch.final_rate).toFixed(0)}/-
              <FormulaFinalRate
                billRate={singleDispatch.bill_rate}
                cashDiscount={singleDispatch.cash_discount}
                discountAmount={singleDispatch.miller_discounted_amount}
                finalRate={singleDispatch.final_rate}
              />
            </Typography>
          </Box>
        ) : (
          "-"
        ),
      "Miller Charges": () =>
        singleDispatch.miller_gst_charge ? (
          <Box>
            <Typography style={{ fontSize: "0.775rem" }}>
              <strong>GST:</strong>{" "}
              {Number(singleDispatch.miller_gst_charge).toFixed(2)}%
            </Typography>
            <Typography style={{ fontSize: "0.775rem" }}>
              <strong>TDS:</strong>
              {/* {Number(singleDispatch.miller_tds).toFixed(2)}% */}
              <FormulaMillerTds
                tds_rate={Number(singleDispatch.miller_tds).toFixed(2)}
                gst={Number(singleDispatch.miller_gst_charge).toFixed(2)}
                bill_amount={Number(singleDispatch.miller_bill_amount).toFixed(
                  0
                )}
              />
            </Typography>
            <Typography style={{ fontSize: "0.775rem" }}>
              <strong>Advance:</strong> ₹{" "}
              {Number(singleDispatch.miller_advance).toFixed(0)}/-
            </Typography>

            <Typography style={{ fontSize: "0.775rem" }}>
              <strong>Bill Amount:</strong>{" "}
              {`₹ ${Number(singleDispatch.miller_bill_amount).toFixed(0)}/-`}
            </Typography>
          </Box>
        ) : (
          "-"
        ),
      Brokerage: () => <Brokerage singleDispatch={singleDispatch} />,
      "Miller Details": () => <MillerDetails singleDispatch={singleDispatch} />,
      "Total Payable": () => <TotalPayable singleDispatch={singleDispatch} />,
      "Other Deduction": () =>
        singleDispatch.other_deduction
          ? `₹ ${Number(singleDispatch.other_deduction).toFixed(0)}/-`
          : "-",
      Action: () =>
        userRole === "admin" ||
        userRole === "accountant" ||
        userRole === "manager" ? (
          <StyledButton
            name={
              singleDispatch.partial_payment?.payment_amount ? "Edit" : "Pay"
            }
            minWidth="0"
            background={primary}
            color={white}
          />
        ) : (
          "-"
        ),
      subList: singleDispatch.subList
        ? singleDispatch.subList.map((singleSub) => {
            singleSub["Date"] = moment(singleSub.payment_datetime).format(
              "ddd, MMM Do YYYY"
            );
            singleSub["Payment Amount"] = singleSub.payment_amount
              ? `₹ ${Number(singleSub.payment_amount).toFixed(0)}/-`
              : "";
            singleSub["Payment Status"] = singleSub.payment_status;
            singleSub["Recorded By"] = singleSub.recorded_by;
            singleSub["Verified By"] = singleSub.verified_by;
            singleSub["Action"] = "rfrfgrgfrtgtr5g";
            singleSub["ActionUI"] = (
              <div>
                {/* <StyledButton
                  name={"Download PDF"}
                  background={white}
                  padding={"2px 6px"}
                  fontSize={"0.8rem"}
                  border={"1px solid rgb(241, 154, 48)"}
                  boxShadow={"none"}
                  // color={white}
                  onClick={() => {
                    this.setState({
                      downloadInvoicePdf: true,
                      selectedDispatch: singleDispatch,
                      selectedPartialPayment: singleSub,
                    });
                  }}
                /> */}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                    setPopper({
                      open: true,
                      data: singleSub,
                      parent: singleDispatch,
                    });
                  }}
                  className="d-flex alignC justifyC"
                  style={{
                    margin: "12px 10px",
                    width: "50px",
                  }}
                >
                  <MoreHorizOutlined />
                </div>
              </div>
            );

            //filterData(
            //   BrandList,
            //   "id",
            //   singleSub.brand,
            //   "onlyOne"
            // )
            //   ? filterData(BrandList, "id", singleSub.brand, "onlyOne")
            //       .brand_name
            //   : "";

            // singleSub["Item Category"] = filterData(
            //   ItemCateoryList,
            //   "id",
            //   singleSub.item_category,
            //   "onlyOne"
            // )
            //   ? filterData(
            //       ItemCateoryList,
            //       "id",
            //       singleSub.item_category,
            //       "onlyOne"
            //     ).name
            //   : "";
            // singleSub["Item Type"] = filterData(
            //   ItemList,
            //   "id",
            //   singleSub.item_type,
            //   "onlyOne"
            // )
            //   ? `${Number(
            //       filterData(ItemList, "id", singleSub.item_type, "onlyOne")
            //         ? filterData(ItemList, "id", singleSub.item_type, "onlyOne")
            //             .broken_percentage
            //         : 0
            //     ).toFixed(0)} %`
            //   : "";
            // singleSub["Packaging"] =
            //   singleSub.dispatch_packaging &&
            //   singleSub.dispatch_packaging.length > 0
            //     ? `  ${
            //         singleSub.dispatch_packaging.map((sP) => {
            //           const singlePack = sP.packaging_details;

            //           return singlePack
            //             ? `${singlePack.size}${singlePack.unit}${" - "}${
            //                 singlePack.bag_type
            //               }`
            //             : "";
            //         })[0]
            //       } Total (...s)`
            //     : "-";
            // singleSub["PackagingUI"] = (
            //   <ShowPackaging
            //     noTotalbags={true}
            //     details={singleSub.dispatch_packaging.map((sP) => {
            //       const singlePack = sP.packaging_details;
            //       singlePack.used_bags = sP.total_bags_dispatched;

            //       return singlePack;
            //     })}
            //   />
            // );
            // singleSub["PackagingUIPdf"] =
            //   singleSub.dispatch_packaging &&
            //   singleSub.dispatch_packaging.length > 0
            //     ? singleSub.dispatch_packaging
            //         .map((sP) => {
            //           const singlePack = sP.packaging_details;

            //           return singlePack
            //             ? `${singlePack.size}${singlePack.unit}${" - "}${
            //                 singlePack.bag_type
            //               }`
            //             : "";
            //         })
            //         .join(", ")
            //     : "-";
            return singleSub;
          })
        : [],
    };
  };

  const renderTable = () => (
    <>
      <Popover
        open={popper.open}
        anchorEl={anchorEl}
        style={{ marginTop: "-2.5%" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <ClickAwayListener
          onClickAway={() => {
            setPopper({ open: false, anchorEl: null });
          }}
        >
          <List>
            {/* <ListItem
              button
              onClick={() => {
                this.setState({
                  openStatusDialog: true,
                  loader: false,
                  Status: this.state.popper.data.payment_status,
                  searchedData: this.state.popper.data.payment_datetime,
                  PaymentAmount: this.state.popper.data.payment_amount,
                });
                setDetails({
                  selectedDispatch: popper.parent,
                  selectedPartialPayment: popper.data,
                });
              }}
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0 0 0 0",
                padding: "10px",
              }}
            >
              <p
                className="d-flex alignC textC"
                style={{
                  margin: "0",
                  fontSize: "0.9rem",
                  height: "24px",
                }}
              >
                Edit
              </p>
            </ListItem> */}
            {popper &&
              popper.data &&
              popper.data.payment_status !== "PENDING" && (
                <ListItem
                  button
                  onClick={() => {
                    setDownloadInvoicePdf(true);
                    setDetails({
                      selectedDispatch: popper.parent,
                      selectedPartialPayment: popper.data,
                    });
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "0 0 0 0",
                    padding: "10px",
                  }}
                >
                  <p
                    className="d-flex alignC textC"
                    style={{
                      margin: "0",
                      fontSize: "0.9rem",
                      height: "24px",
                    }}
                  >
                    Download Pdf
                  </p>
                </ListItem>
              )}
          </List>
        </ClickAwayListener>
      </Popover>
      {downloadInvoicePdf === true ? (
        <InvoiceCardUi
          onlyShow={false}
          setLoader={() => {
            setLoader();
          }}
          onDownload={() => {
            setLoader();
            setDownloadInvoicePdf(false);
          }}
          onlyDownload={true}
          singlelistView={singlelistView}
          module="miller"
          pdfHeader={[
            "Payment Status",
            "Whose Payment",
            "Final Amount",
            "Payment Amount",
            "Unpaid Amount",
            "Recorded By",
            "Verified By",
          ]}
          header={[
            "Payment Status",
            "Whose Payment",
            "Final Amount",
            "Payment Amount",
            "Unpaid Amount",
            "Recorded By",
            "Verified By",
          ]}
          setData={pdfFormat}
          loader={loader ? loader : false}
          partial_payment={{
            ...details.selectedPartialPayment,
            account_detail: details.selectedDispatch,
          }}
        />
      ) : (
        ""
      )}
      <TableComponent
        rowheight="75px"
        filterChild={filterBypo}
        descending={true}
        pagination={{
          count: dispatchListAllData?.count ?? 0,
          next: dispatchListAllData.next,
          previous: dispatchListAllData.previous,
          customPagination: true,
          tablePagination: (url) => {
            onTabChange(
                STATUS_OPTIONS[selectedTab].value === "ALL"
                  ? ""
                  : STATUS_OPTIONS[selectedTab].value === "PENDING"
                  ? "UNPAID"
                  : STATUS_OPTIONS[selectedTab].value,
                url
              );
          },
        }}
        loader={loader}
        noAddButton
        header={DetailedHeader ? DetailedHeader : CondensedHeader}
        tableList={generateMergedList(tableList)}
        actions={[]}
      />
    </>
  );

  return (
    <TabComponent
      onChange={(newTab) => {
        console.log(newTab);
        setTab(newTab)
      }}
      list={STATUS_OPTIONS.map(({ label, value }) => ({
        name: label,
        component: renderTable(),
      }))}
    />
  );
}

export default TransporterAccounts;
